
export enum ModuleType {
  READING = 'READING',
  LISTENING = 'LISTENING',
  WRITING_T1 = 'WRITING_T1',
  WRITING_T2 = 'WRITING_T2',
  SPEAKING = 'SPEAKING',
  MEMORY_PALACE = 'MEMORY_PALACE',
  ANALYTICS = 'ANALYTICS',
  QUICK_DRILL = 'QUICK_DRILL',
  PRICING = 'PRICING',
  VOCAB_MATRIX = 'VOCAB_MATRIX',
  AUDIO_WAVEFORM = 'AUDIO_WAVEFORM',
  TIME_WARP = 'TIME_WARP',
  VOCAB_SLOTS = 'VOCAB_SLOTS',
  GRAMMAR_BATTLE = 'GRAMMAR_BATTLE',
  WRITING_FLOW = 'WRITING_FLOW'
}

// --- Session 1 & 4 (Reading) ---
export interface ReadingPassage {
  title: string;
  paragraphs: string[];
  difficulty: 'easy' | 'medium' | 'hard';
  wordCount: number;
  keyVocab: Array<{ word: string; definition: string; context: string }>;
  questions: Array<{ question: string; options: string[]; answer: string }>;
}

export interface LogicPuzzle {
  passage: string;
  statements: Array<{
    id: number;
    statement: string;
    correctAnswer: 'TRUE' | 'FALSE' | 'NOT GIVEN';
    explanation: string;
  }>;
}

// --- Session 2 (Listening) ---
export interface ListeningScript {
  scenario: string;
  audioText: string;
  questions: Array<{ question: string; options: string[]; answer: string }>;
  traps: Array<{ text: string; explanation: string }>;
}

export type Direction = 'NORTH' | 'EAST' | 'SOUTH' | 'WEST';

// --- Session 3 (Writing T1) ---
export interface ChartDataPoint {
  label: string;
  value: number;
  color?: string;
}

export interface ChartData {
  type: 'bar' | 'line' | 'pie';
  data: ChartDataPoint[];
  description: string;
  keyTrends: string[];
}

// --- Session 5 (Writing T2) ---
export interface EssayPrompt {
  question: string;
  type: 'opinion' | 'discussion' | 'problem-solution';
  context: string;
  keyWords: string[];
  sampleIdeas: string[];
}

// --- Session 6 (Speaking) ---
export interface Enhancement {
  original: string;
  enhanced: string;
  improvements: string[];
  bandScore: number;
}

export interface CueCard {
  topic: string;
  bulletPoints: string[];
  followUp: string[];
}

// --- Session 7 (Memory Palace) ---
export interface WordFamily {
  root: string;
  derivatives: Array<{ word: string; type: string }>;
  mnemonic: string;
  location: string;
}

// --- Advanced Modules ---
export interface GrammarChallenge {
  sentence: string;
  errorType: string;
  options: string[]; // 4 options, one correct
  correctAnswer: string;
  explanation: string;
  difficulty: 'easy' | 'medium' | 'hard';
}

// --- Performance ---
export interface PerformanceData {
  reading: number;
  listening: number;
  writing: number;
  speaking: number;
  overall: number;
  streak: number;
  history: Array<{ date: string; score: number }>;
}
